<template>
  <div class="hb-reject-dialog">
    <el-dialog title="驳回原因" :visible.sync="dialogAddUserSchoolChoice" width="60%" center>
      <el-form size="small" label-width="120px"  ref="ruleFormaa" >
        <el-form-item label="原因：" prop="">
          {{content}}
        </el-form-item>
        <el-form-item label="附件：" v-if="url">
          <el-link :underline="false" type="primary" @click="()=>{previewUrl=url}">
            预览/下载
            <i style="color: #0e90d2;font-size: 18px;margin-left: 10px" class="el-icon-download"></i>
          </el-link>
        </el-form-item>
        <el-form-item label="附件：" v-else>
          <div style="color:red">未上传</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddUserSchoolChoice = false">取 消</el-button>
      </div>
    </el-dialog>
    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="previewUrl=null;previewName=null"/>
  </div>
</template>
<script>
import {exportFileDocument} from '@/api/file'
import HBFilePreview from '@/components/HBCommon/HBFilePreview/HBFilePreview';
export default {
  name: "reject_rejection",
  components: {
    HBFilePreview
  },
  data() {
    return {
      previewUrl:null,
      previewName:null,
      dialogAddUserSchoolChoice: false,
      content: '',
      url: ''
    };
  },
  methods: {
    sendItem(content,url,reject_type) {
      this.dialogAddUserSchoolChoice = true
      var str = content;
      if (reject_type) {
        str = reject_type + ' | ' + str
      }
      this.content = str;
      this.url = url;
    },
    exportFile(data, fileName){ // url name
      exportFileDocument(data,fileName)
    },
  }
};
</script>

<style lang="scss">
.hb-reject-dialog {
  .upload-demo {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    .control-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      .tip-text {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/reason_rejection.vue